var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{attrs:{"type":"error","outlined":"","value":true,"icon":"block"}},[_vm._v("\n\tSorry. You don't have rights to access this page.\n")])}
var staticRenderFns = []

export { render, staticRenderFns }